import type { MaterialGroupBy } from 'common/models';
import { unitShortcut } from 'helpers/materialHelpers';
import { valueCurrencyShortcut } from 'helpers/priceHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import type { OrderMaterial } from 'pages/orders/models';
import React from 'react';

interface Props {
  material: OrderMaterial;
  visibleColumns?: string[];
  groupByKey?: MaterialGroupBy;
  currencyId: string;
  showPrice?: boolean;
}

const MaterialTableRow: React.FC<Props> = (props): React.ReactElement => {
  const { currencyId, material, groupByKey, visibleColumns, showPrice } = props;

  const { t } = useCustomTranslation();

  return (
    <tr key={material.id}>
      {(!visibleColumns || visibleColumns.includes('name')) && <td>{material.name}</td>}
      {(!visibleColumns || visibleColumns.includes('identificationNumber')) && (
        <td>{material.identificationNumber}</td>
      )}
      {(!visibleColumns || visibleColumns.includes('storeName')) && groupByKey !== 'store' && (
        <td>{material.storeName}</td>
      )}
      {(!visibleColumns || visibleColumns?.includes('categoryName')) &&
        groupByKey !== 'category' && <td>{material.categoryName}</td>}
      {visibleColumns?.includes('supplierName') && <td>{material.supplierName}</td>}
      {visibleColumns?.includes('supplierCode') && <td>{material.supplierCode}</td>}
      {visibleColumns?.includes('description') && <td>{material.description}</td>}
      <td>{`${material.amount} ${t(unitShortcut(material.unit))}`}</td>
      {showPrice && (
        <>
          <td className="priceCol">{valueCurrencyShortcut(material.price || 0, currencyId, t)}</td>
          <td className="priceCol">
            {valueCurrencyShortcut((material.price || 0) * material.amount, currencyId, t)}
          </td>
        </>
      )}
    </tr>
  );
};

export default MaterialTableRow;
